class applicationInfoController {

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.selectedContact = this.customer;
    }
}

export const APPLICATION_INFO_CONTROLLER = ['$scope', applicationInfoController];